export const ACTIVATE_ACCOUNT_SUBTITLE_BY_STATUS = {
  validating: 'Estamos validando tu invitación.',
  validation_error: 'No pudimos validar tu invitación. Intenta nuevamente.',
  invalid: 'El enlace de activación no es válido.',
  expired: 'El enlace de activación expiró. Solicita uno nuevo a la persona que administra los usuarios.',
  success: 'Tu cuenta fue activada correctamente. Ya puedes ingresar a Torre de Control.'
}

export const ACTIVATE_ACCOUNT_DEFAULT_SUBTITLE =
  'Define tu contraseña para ingresar a Torre de Control.'

export const ACTIVATE_ACCOUNT_PERSONALIZED_SUBTITLE = (userName) =>
  `Hola, ${userName}. Define tu contraseña para terminar de activar tu cuenta.`

export const ACTIVATE_ACCOUNT_PASSWORD_ERROR_MESSAGE =
  'La contraseña no cumple con las reglas requeridas.'

export const ACTIVATE_ACCOUNT_SUCCESS_ALERT_MESSAGE =
  'Tu cuenta fue activada correctamente. En el primer acceso deberás activar la autenticación en dos pasos.'
